import * as React from "react";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { tokens } from "../theme";

/**
 * Breadcrumbs, per the book's Navigation section.
 *
 * Shown only past the second level — a trail that reads "People / Priya Raman"
 * tells you nothing you cannot see from the page itself, so it is noise. The
 * trail earns its place once you are deep enough to have lost track of where
 * you came from.
 *
 * The last crumb is where you are: ink and 600, not a link. Everything before
 * it is plum and clickable, with a faint separator that should read as
 * punctuation rather than as another item in the list.
 */
const CustomSeparator = ({ breadcrumbs }) => {
  const trail = (breadcrumbs || []).filter((b) => b && b.label);

  // Only past the second level.
  if (trail.length < 3) return null;

  return (
    <Box
      aria-label="breadcrumb"
      component="nav"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        flexWrap: "wrap",
        fontSize: "0.75rem",
        color: tokens.primary,
        mb: "1.5rem",
      }}
    >
      {trail.map((crumb, i) => {
        const last = i === trail.length - 1;
        return (
          <React.Fragment key={i}>
            {i > 0 && (
              <Box component="span" aria-hidden="true" sx={{ color: tokens.textFaint }}>
                /
              </Box>
            )}
            {last ? (
              <Box component="span" aria-current="page" sx={{ color: tokens.text, fontWeight: 600 }}>
                {crumb.label}
              </Box>
            ) : (
              <Link
                to={crumb.to || crumb.href || "#"}
                style={{ color: "inherit", textDecoration: "none" }}
              >
                {crumb.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default CustomSeparator;
